export default theme => ({
  parentContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  tooltipContainer: {
    display: 'flex'
  },
  marginRight: {
    marginRight: theme.spacing(1)
  },

  coloredBar: {
    height: 24,
    margin: 0,
    width: '100%',
    backgroundColor: 'transparent',
    borderRadius: 5,
    display: 'flex'
  },
  segmentsContainer: {
    display: 'flex',
    width: '100%',
    '& > div:last-child': {
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius
    },
    '& > div:first-child': {
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius
    }
  },
  segment: {
    color: theme.palette.white
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(1),
    cursor: 'pointer'
  },
  total: {
    marginLeft: theme.spacing(1),
    minWidth: theme.spacing(3)
  },
  cursorDefault: {
    cursor: 'default'
  }
});
